import { post } from '@/utils/network';
import moment from 'moment';
import { CourseHomeNameMap, InterfaceCourseHomeData } from '@/utils/dictionary';
import { StructuredType } from 'typescript';

export interface InterfaceHeaderInfo {
  stopcode: '0' | '1';
  coursename: string;
  studentCount: string;
  selectStudentCount?:string;
  isattest?:boolean;
  groupCount: string;
  classname: string;
  code: string;
  types?: string;
  identity?: string;
  theme: {
    minpic: string;
  };
}
export function getCourseHeaderInfo(arg: { courseid: string, vtr_type?: string }) {
  return post<InterfaceHeaderInfo>('/CourseBigDataApi/getCourseBaseDataV2', arg);
}

interface Common {
  contenttype: keyof InterfaceCourseHomeData;
  name: string; // 前端自处理的
  id: string;
  item_type: string; // 默认1
  dirid: string; // 章节id
  title: string; // 标题
  state: number; // 1未发布 2未开始 3 进行中 3 已结束
  startTime: number; // 创建时间或者发布时间
  endTime: number; // 结束时间
  startTimeStr: string; // 创建时间格式化
  endTimeStr: string; // 结束时间格式化
  children: [];
  currentPage: number;
  pageSize: number;
  finished: false;
}
interface CourseWare extends Common {
  contenttype: 1; // 1
  item_type: string; // 默认1
  title: string; // 标题
  dirid: string; // 目录id
  createtime: string;
  attachment: Array<any>; // 附件信息
  stepTotal: string; // 试题数量
  stepStudentInfo: {
    corrected: string; // 已批人数
    unCorrected: string; // 未批人数
  };
  prestudyStudentInfo: {
    finishCount: string; // 已经学完的
    studyCount: string; // 正在学习的
    score: string;
  };
  totalScore: number;
  task: {
    score: string; // 分数
    publish_time: string;
    endtime: string;
    interactState: number; // 1未发布| 2未开始 | 3 进行中| 4已结束
    allowdown: string; // 允许下载
    allowAnswer: string; // 允许作答
    pages: string; // 页数
    pagesStr: string; // 页数格式化后
  };
  learning: string; // 0~1 学习进度
}
interface Material extends Common {
  contenttype: 2 | 8 | 9 | 10;
  realType: number; // 用于复制原本的type，判断是否外链
  studentState: number; // 学习状态判断  -1未学习 0学习中，1完成了学习
  item_type: string; // 默认1
  logid: string;
  courseid: string;
  dirid: string;
  createtime: string;
  attachment: string | Array<any>;
  sort: string;
  candownload: string;
  parent: string;
  isfolder: string;
  foldername: string;
  title: string;
  studyduration: string;
  duration: string;
  fullscore: number;
  fullcount: number; // 回复评论数
  endtime: string;
  id: string;
  status: string; // 0已发布 1删除 2未发布 3 进行中 4 已结束
  lessonlink: [];
  filetype: { id: number; name: string }[];
  authorinfo: {
    username: string;
  };
  statistics: {
    learning: number;
    unlearned: number;
    completed: number;
  };
}
interface Answer extends Common {
  contenttype: 3; // 3
  item_type: string; // 默认1
  id: string; // 互动答题id
  title:string;//标题
  createtime: string; // 创建时间
  type: string;
  enable: string;
  over: string;
  nomarkCount: number; // 未批改人数
  markCount: number; // 批改人数
  submitCount: number; // 提交总数
  nosubmitCount: number; // 未参与人数
  publishState: number; // 互动答题的发布状态【0未发布1未开始2进行中3已结束】
  TestpaperScore: number; // 互动环节下试卷总分
  begintime: string; // 开始时间
  endtime: string; // 结束时间
  lessonlink: []; // 应用环节
  // 学生提交情况
  studentSubmitState: number; // 提交状态【-1未参与，0:未提交1:已提交2:已批改】
  studentLastgrade: number; // 最终成绩
}
interface HomeWork extends Common {
  contenttype: 4; // 4
  item_type: string; // 默认1
  HomeWorkid: string; // 作业id
  title: string; // 作业标题
  description: string; // 描述
  createtime: string;
  updatetime: string;
  ispublish: string; // 发布状态【0：未发布1：发布】
  type: string; // 作业类型【0：个人作业，1：小组作业】
  attachment: {
    fileid: string;
    ext: string;
    ext_s: string;
    ext_type: string;
    size: string;
    name: string;
    url: string;
    date: string;
    isPic: number;
    thumb_src: string;
    src: string;
    rurl: string;
  }[]; // 附件
  checkrepeat: string; // 是否需要进行作业查重【1：需要，0：不需要】
  autorebackrate: string; // 查重率【0~1之间的值，-1：不开启】
  warmingcheckrate: string; // 查重警戒线【0~1之间的值】
  isallowdelay: string; // 是否允许延迟提交【1：允许，0：不允许】
  fullscore: string; // 满分
  timestate: string; // 状态
  publish_time: string; // 发布时间
  endtime: string; // 作业截止时间
  lessonlink: [
    // 应用环节
    {
      type: number;
      name: string;
    },
    {
      type: number;
      name: string;
    }
  ];
  statistics: {
    // 统计数据
    HomeWorkAllCount: number; // 全部应交数量
    submitCount: number; // 作业提交数量
    rCount: number; // 批改数量
    nrCount: number; // 未批改树
    nSubmitCount: number; // 未交数
  };
  mstatus: number; // 作业状态【0:未提交 1：已提交 2：已批改  3：被打回 4：成绩未公布】
  grade: string; // 作业成绩
}
interface CaseStudy extends Common {
  contenttype: 25; // 25
  item_type: string; // 默认1
  id: string; // 作业id
  title: string; // 作业标题
  description: string; // 描述
  createtime: string;
  updatetime: string;
  ispublish: string; // 发布状态【0：未发布1：发布】
  fullscore: string; // 满分
  timestate: string; // 状态
  publish_time: string; // 发布时间
  endtime: string; // 作业截止时间
  lessonlink: [
    // 应用环节
    {
      type: number;
      name: string;
    },
    {
      type: number;
      name: string;
    }
  ];
  statistics: {
    // 统计数据
    HomeWorkAllCount: number; // 全部应交数量
    submitCount: number; // 作业提交数量
    rCount: number; // 批改数量
    nrCount: number; // 未批改树
    nSubmitCount: number; // 未交数
  };
  mstatus: number; // 作业状态【0:未提交 1：已提交 2：已批改  3：被打回 4：成绩未公布】
  grade: string; // 作业成绩
}

interface Topic extends Common {
  status: string; // 0已发布 1删除 2未发布 3 进行中 4 已结束
  studentState: number; // 0 未参与 1 已参与
  contenttype: 5; // 5
  item_type: string; // 默认1
  essence: string; // 精华 1 0
  sort: string; // 置顶1 0
  is_owner:number;//是否自己发布
  fullcount: number; // 需回复数
  fullscore: number;
  lessonlink: [];
  releasetime: null; // 发布时间
  scoringtime: string; // 截止时间，若不设置截止时间则返回： 0
  topic_type?: number; // 话题类型：0 普通话题，1 答题型话题
  quiz_id?: string; // 答题型话题的 quiz_id
  statistics: {
    comment: number; // 评论
    jointotal: number; // 参与
    nojoin: number; // 未参与
  };
  quiz_statistics?: {
    submitted: number; // 已答题人数
    not_submitted: number; // 未答题人数
    avg_score: number | null; // 平均分
  };
}
interface Test extends Common {
  contenttype: 6; // 6
  item_type: string; // 默认1
  title: string; // 标题
  share: string; // 是否分享该试卷【1：是 0：否】
  type: string; // 试卷的类型【0：普通测试  1：练习    10：线下测试】
  testpaperType: number; // 1未发布 2未开始 3 进行中 3 已结束
  begintime: number; // 创建时间，
  endtime: number;
  rCount: number; // 已批 （老师端）
  nrCount: number; // 未批（老师端）
  nSubmitCount: number; // 未交（老师端）
  totalScore: number; // 试卷总分
  fullscore: number;
  submit_state: number; // 备注如下
  // testpaperType === 3  进行中时
  // 1未参与[前往答题]
  // 2已参与 未提交 [继续答题]
  // 3被打回 [重新答题]
  // 4老师设置查看试卷 [查看试卷]
  // 5老师设置不可查看试卷 [没有按钮]
  // 6老师设置查看试卷 [成绩XXXX 可查看试卷]
  // 7老师设置不可查看试卷 [成绩XXXX 点击不可查看看试卷]
  // 8老师设置查看试卷 [成绩未公布 可查看试卷]
  // 9老师设置不可查看试卷 [成绩未公布 点击不可查看看试卷]
  // testpaperType === 4 已结束
  // 1老师设置查看试卷 [查看试卷]
  // 2老师设置不可查看试卷 [没有按钮]
  // 3老师设置查看试卷 [查看试卷]
  // 4老师设置不可查看试卷 [没有按钮]
  // 5被打回 [重新答题]
  // 6[查看试卷]
  // 7[没有按钮]
  // 8[成绩xxx 点开可查看]
  // 9[成绩未公布 点开可查看]
  // 10[成绩XXX 不可点击查看看]
  // 11[成绩未公布 不可点击查看看]
}
interface Notice extends Common {
  status: string; // 0已发布 1删除 2未发布 3 进行中 4 已结束
  contenttype: 7; // 7
  studentState: number;
  item_type: string; // 默认1
  id: string;
  courseid: string;
  dirid: string; // 章节id
  title: string;
  content: string;
  createtime: string;
  releasetime: string;
  lessonlink: [];
  isRead?: boolean;
  statistics: {
    jointotal: number; // 参与人数
    nojoin: number; // 未参与人数
    comment: number; // 评论数
  };
}
interface Video extends Common {
  status: string; // 0已发布 1删除 2未发布 3 进行中 4 已结束
  contenttype: 20 | 21; // 20 直播，21录播
  studentState: number; // 学习状态判断  -1未学习 0学习中，1完成了学习
  item_type: string; // 默认1
  logid: string;
  courseid: string;
  dirid: string;
  createtime: string;
  attachment: string | Array<any>;
  candownload: string;
  parent: string;
  isfolder: string;
  foldername: string;
  title: string;
  duration: string;
  start_time: string;
  stop_time: string;
  id: string;
  lessonlink: [];
  filetype: { id: number; name: string }[];
  authorinfo: {
    username: string;
  };
  statistics: {
    studentTotalCount?: number; // 学生总人数
    joinLiveCount?: number; // 参加直播的人数
    averageOnlineTime?: number; // 平均在线时长 此字段 直播才有值
    joinVisitCount?: number; // 回顾人数
    noJoinVisitCount?: number; // 未回顾人数
    completed?: number; // 已完成
    unlearned?: number; // 未学习
  };
}
interface Conference extends Common {
  status: string; // state  -1 删除会议 | -2  取消会议 | -3 结束会议 | 0 取消会议  | 1 正常 | 2 未开始 | 3 进行中 | 4 已结束 ps: 0 不可能出现 每次获取列表时 会自动同步状态
  contenttype: 22; // 20 直播，21录播
  item_type: string; // 默认1
  logid: string;
  courseid: string;
  dirid: string;
  createtime: string;
  attachment: string | Array<any>;
  download: string | null;
  join_url: string;
  parent?: string;
  isfolder: string;
  foldername: string;
  title: string;
  duration: string;
  start_time: string;
  end_time: string;
  id: string;
  lessonlink: [];
  filetype: { id: number; name: string }[];
  authorinfo: {
    username: string;
  };
}
// 章节时，只显示章节名和数量
interface Chapter {
  dirid: string; // 章节id
  contenttype: 0; // 7
  createtime: string;
  id: string; // 章节id
  item_type: string; // 章节时为 2
  name: string;
  sort: string; // PC端有用
  children?: (CourseWare | Material | Answer | HomeWork | Topic | Test | Notice | Conference | CaseStudy)[];
  currentPage: number;
  pageSize: number;
  finished: false;
}
export interface FolderListIF {
  contentid: string
  contenttype: string
  count: string | number
  createtime: string
  id: string
  index: string | number
  item_type: string | number
  name: string
}
export type InterfaceCourseHomeItem = CourseWare | Material | Answer | HomeWork | Topic | Test | Notice | Video | Chapter | Conference | CaseStudy;

// 课程首页列表数据总共7种，此方法格式化为统一格式
// @ts-ignore
// eslint-disable-next-line consistent-return
function courseListFormatDate(value: InterfaceCourseHomeItem): InterfaceCourseHomeItem {
  if (String(value.item_type) === '2' || String(value.item_type) === '3') {
    // 章节不需要格式化
    //value.children = value.children?value.children:[];
    value.currentPage = 0;
    value.pageSize = 10;
    value.finished = false;
    if(value.children){
      //@ts-ignore
      value.children = value.children.map<InterfaceCourseHomeItem>(courseListFormatDate);
    }
    return value;
  }
  // @ts-ignore
  value.contenttype = Number(value.contenttype);
  try {
    if (value.contenttype === 1) {
      // 课件
      value.state = value.task.interactState;
      value.startTime = Number(value.task.publish_time);
      value.endTime = Number(value.task.endtime);

      value.totalScore = Number(value.task.score);
      // 将“1|3|4|5|6|7|8|9|10|11|12|13|14|15|16|17|18|19|20|21|22|23|24”转换为 "1，3-15页"
      if (value.task.pages) {
        const _arr: string[] = value.task.pages.split('|');
        _arr.forEach((item, index) => {
          if (index === 0) {
            value.task.pagesStr = item;
          } else if (Number(item) - 1 !== Number(_arr[index - 1])) {
            // 若与上一位不连续
            // 判断上一位与上上一位是否连续
            if (Number(_arr[index - 1]) - 1 === Number(_arr[index - 2])) {
              // 连续
              value.task.pagesStr += `-${_arr[index - 1]}，${item}`;
            } else {
              // 不连续
              value.task.pagesStr += `，${item}`;
            }
          } else if (index === _arr.length - 1) {
            // 结束，加入最后一位
            value.task.pagesStr += `-${item}`;
          }
        });
      }
    } else if (value.contenttype === 2 || value.contenttype === 8 ||value.contenttype === 9 || value.contenttype === 10) {
      // 资料
      value.startTime = Number(value.createtime);
      value.endTime = Number(value.endtime);
      value.studentState = value.state;
      value.fullscore = Number(value.fullscore);

    } else if (value.contenttype === 3) {
      // 互动答题
      value.state = value.publishState + 1;
      value.startTime = Number(value.begintime);
      value.endTime = Number(value.endtime);
    } else if (value.contenttype === 4) {
      // 作业
      value.state = Number(value.timestate) + 1;
      value.startTime = Number(value.publish_time);
      value.endTime = Number(value.endtime);
    } else if (value.contenttype === 5) {
      // 话题
      value.startTime = Number(value.releasetime);
      value.endTime = Number(value.scoringtime);
      value.fullcount = Number(value.fullcount);
      value.fullscore = Number(value.fullscore);
    } else if (value.contenttype === 6) {
      // 测试
      value.state = value.testpaperType;
      value.startTime = value.begintime;
      value.endTime = value.endtime;

      value.totalScore = Number(value.totalScore);
      value.fullscore = Number(value.fullscore);
    } else if (value.contenttype === 7) {
      // 公告目前不做操作
      value.startTime = Number(value.releasetime);
    } else if (value.contenttype === 20) {
      // 直播
      value.startTimeStr = value.start_time;
      value.endTimeStr = value.stop_time;
      value.studentState = value.state;
      value.state = 3;
      if(value.statistics){
        value.statistics.completed = value.statistics.joinLiveCount;
        value.statistics.unlearned = value.statistics.noJoinVisitCount;
      }
    } else if (value.contenttype === 21) {
      // 录播
      value.startTimeStr = value.start_time;
      value.endTimeStr = value.stop_time;
      value.studentState = value.state;
      value.state = 3;
      if(value.statistics){
        value.statistics.completed = value.statistics.joinVisitCount;
        value.statistics.unlearned = value.statistics.noJoinVisitCount;
      }
    } else if (value.contenttype === 22) {
      // 腾讯会议
      value.startTime = Number(value.start_time);
      value.endTime = Number(value.end_time);
      value.state = Number(value.state);
    }else if (value.contenttype === 25) {
      // 作业
      value.state = Number(value.timestate) + 1;
      value.startTime = Number(value.publish_time);
      value.endTime = Number(value.endtime);
    } 

    // 后端状态处理
    // @ts-ignore
    if (value.contenttype === 2 || value.contenttype === 9 || value.contenttype === 5 || value.contenttype === 7 || value.contenttype === 8 || value.contenttype === 10) {
      // state: number; // 1未发布 2未开始 3 进行中 4 已结束
      // status: string; // 0已发布 1删除 2未发布 3 进行中 4 已结束
      let state: number = 0;
      if (Number(value.status) === 0) {
        state = 2;
      } else if (Number(value.status) === 2) {
        state = 1;
      } else {
        state = Number(value.status);
      }
      // 学生-后端返回的state是已读未读，这里state已被占用，所以新开辟了个字段
      if (value.contenttype === 7) {
        value.isRead = value.state === 1;
        if (Number(value.status) === 3) {
          state = 2;
        }
      }
      value.studentState = Number(value.state);
      value.state = state;
    }
    //公告
    
    // 腾讯会议
    if (value.contenttype === 22) {
      // state  -1 删除会议 | -2  取消会议 | -3 结束会议 | 0 取消会议  | 1 正常 | 2 未开始 | 3 进行中 | 4 已结束 ps: 0 不可能出现 每次获取列表时 会自动同步状态
      // status 0 正常 （已发布） 1 删除    2 未发布
      if (Number(value.status) === 2) {
        value.state = 1;
      }
    }
    if (value.contenttype !== 0) {
      // @ts-ignore
      value.startTimeStr = value.startTime && value.startTime !== '0' ? moment(value.startTime * 1000).format('YY/MM/DD HH:mm') : value.startTimeStr;
      // @ts-ignore
      value.endTimeStr = value.endTime && value.endTime !== '0' ? moment(value.endTime * 1000).format('YY/MM/DD HH:mm') : '不限';
    }
    if(value.contenttype === 20 || value.contenttype === 21){
      value.name = value.title;
    }else{
      value.name = CourseHomeNameMap[value.contenttype];
    }
    return value;

  } catch (err) {
    console.log(err);
  }

}
// 课程首页列表
export function getCourseContentList(arg: {
  courseid: any; // 课程id
  contenttype: number | number[]; // 课堂类型 默认0
  dirid: string; // 章节id 默认0
  lessonlink: number[]; // 环节id 默认 空
  page: number; // 页面 默认1
  limit: number; // limit 默认 50
  desc: string; // 是否章节排序 1 时间排序 2章节排序})
  courserole:any;//课程的角色,需要转为 int 型
  vtr_type?:string;//来源是否为虚拟教研室
  sort?:any;//排序
}) {
  if(arg['courserole'] != null){
    arg['courserole'] = parseInt(arg['courserole']);
  }
  return new Promise<{
    count: {
      active: number; // 活动数量
      directory: string; // ，章节数量
    };
    currentPage: number;
    pageSize: number;
    pageTotal: number;
    total: string;
    list: InterfaceCourseHomeItem[];
  }>((resolve, reject) => {
    post<{
      count: {
        active: number; // 活动数量
        directory: string; // ，章节数量
      };
      currentPage: number;
      pageSize: number;
      pageTotal: number;
      total: string;
      list: InterfaceCourseHomeItem[];
    }>('/FutureV2/CourseMeans/getCourseContent', arg).then(res => {
      res.list = res.list.map<InterfaceCourseHomeItem>(courseListFormatDate);
      resolve(res);
    });
  });
}
// 环节列表
export function getHuanjieList(arg: {
  courseid: string; // 课程id
}) {
  return post<
    {
      id: number;
      type: number;
      name: string;
    }[]
  >('/Pcv4/Preparelessons/lessonlinkList', arg);
}
// 获取学生学习进度及学习详情
export function getStudyProgress(arg: {
  courseid: any; // 课程id
}) {
  return post('/FutureV2/CourseMeans/getStudyProgress', arg);
}
// 获取当前课程同步数据倒计时
export function getIsSynchronousCountdown(arg: {
  courseid: string; // 课程id
}) {
  return post<{
    countdowns: number;
    isSynchronous: number;
  }>('/FutureV2/CourseMeans/getIsSynchronousCountdown', arg);
}
// 课程-详情【游客】
export function getCouseInfo(arg: {
  courseid: string; // 课程id
}) {
  return post('/CourseShareNoAuthApi/getCouseInfo', arg);
}
// 产品动态
export function getUpdates(arg: {}) {
  return post('/HelpApi/getUpdates', arg);
}
// 帮助中心
export function getCategoryList(arg: {}) {
  return post('/HelpApi/getCategoryList', arg);
}
// 产品动态-详情
export function getUpdateContent(arg: {
  id: string; // 课程id
}) {
  return post('/HelpApi/getUpdateContent', arg);
}
export function getContentListByCategoryId(arg: {
  categoryid: string; // 课程id
}) {
  return post('HelpApi/getContentListByCategoryId', arg);
}
// 帮助中心-详情
export function getContentInfo(arg: {
  id: string; // 课程id
}) {
  return post('/HelpApi/getContentInfo', arg);
}
// 帮助中心-搜索
export function getContentListBySearch(arg: {
  search: string; // 课程id
}) {
  return post('/HelpApi/getContentListBySearch', arg);
}

// 发送反馈信息
export function sendFeedback(arg: {
  username: string; 
  school: string;
  email: string;
  content: string;
  type: string;
}) {
  return post('/HelpApi/sendFeedback', arg);
}
interface meetingInfo {
  description: string;
  id: string;
  join_url: string;
  meeting_code: string;
  meeting_id: string;
  title: string;
}
export interface LiveInfoInterface {
  status: boolean; // 是否上课中
  classtimeid: string; // 课堂小结id
  coursename: string;
  type: number; // 类型 0没开 1直播 2同屏 3录播
  interactid: string; // 课件id
  meetingInfo: null | meetingInfo; // 腾讯会议信息
  classtimemastervip: boolean; // 是否会员
  supportAnimationSameScreen:number;//是否支持动画同屏
}
// 学生获取上课状态信息
export function getCourseLiveInfo(arg: {
  classid: string; // 课程id
}) {
  return post<LiveInfoInterface>('/Futurev2/AttendClass/classTimeStatus', arg);
}

// 获取腾讯会议进行中列表
export function getConductMeeting(params: {courseid: string}) {
  return post('/Futurev2/TencentMeeting/getConductMeeting', params)
}

// 切换目录-添加到章节
export function postCourseMoveDir(arg: {
  courseid: string; // 课程id
  contenttype: keyof InterfaceCourseHomeData; // 类型
  id: string;
  dirid: string; // 要添加的章节的id
}) {
  return post('/Futurev2/CourseMeans/directoryChange', arg);
}

// 删除
export function postListDelete(arg: {
  courseid: string; // 课程id
  contenttype: keyof InterfaceCourseHomeData; // 类型
  id: string;
}) {
  return post('/FutureV2/CourseMeans/deleteContent', arg);
}

// 重命名  视频和录屏
export function postRename(arg: {
  courseid: string; // 课程id
  id: string; // 视屏id
  title: string; // 名称
  candownload: string | null; // 是否可以下载 0 否 1 可以 默认传递 null
}) {
  return post('/FutureV2/Courseware/updateVideo', arg);
}

// page	页数 1		[string]
// 2	limit	限制 默认20		[string]
// 3	type	[1: 分层 分页返回,2 : 树形数据结构返回] 默认1	是	[string]
// 4	parent	父级id	是	[string]
// 5	courseid	课程id

// 获取资料文件夹列表2020
export function getCoursewareFolderList(arg: {
  page: number; // 页数
  limit: number; // 限制 默认20
  type: number; // [1: 分层 分页返回,2 : 树形数据结构返回] 默认1
  parent: string | null; // 父级id
  courseid: string // 课程id
}) {
  return post('/FutureV2/Courseware/updateVideo', arg)
}

// 老师端 获取 课堂评价汇总信息
export function getClassSummaryInfo(arg: {
  courseid: string;
  begintime: string | number;
  endtime: string | number
}) {
  return post('Classtime/getClassSummaryInfo', arg)
}

// 获取一道随机课堂评价题目
export function getClassSubject(arg: {
  classtimeid: string;
}) {
  return post('/Classtime/getClassSubject', arg)
}
// 保存 学生 评分 以及选项
export function saveEvaluation(arg: {
  star: number | string;
  subjectid: string ;
  answer: string ;
  courseid: string;
  classtimeid: string;
}) {
  return post('/Classtime/saveEvaluation', arg)
}
// 课程评教-获取待评价状态
export function getCheckCourse(arg: {
  courseid: string;
}) {
  return post('/EvaluationTeacherApi/checkCourse', arg)
}
// 课程评教-评教的的试题列表
export function getSubjectList(arg: {
  evalid: string;
}) {
  return post('/EvaluationTeacherApi/getSubjectList', arg)
}
// 课程评教-保存答案
export function evaluationTeacherSaveAnswer(arg: {
  evalid: string;courseid: string;subjectid: string;answer: string;
}) {
  return post('/EvaluationTeacherApi/saveAnswer', arg)
}
// 课程评教-保存答案
export function submitHandup(arg: {
  evalid: string;courseid: string;
}) {
  return post('/EvaluationTeacherApi/handupV2', arg)
}

// 获取当前课程底下所有的课堂记录
export function getClassTimeStatus(arg: {
  courseid: string;
}) {
  return post('/Classtime/getClassList', arg)
}
// 获取课堂小结详情
export function getClassTimeInfo(arg: {
  classtimeid: string;
}) {
  return post('/Classtime/getClassTimeInfo', arg)
}
// 获取课堂小结list
export function getDetailList(arg: {
  classtimeid: string;
  limit: string;
  page: string;
  type: string;
}) {
  return post('/FutureV2/ClassRecord/lists', arg)
}
// 获取弹幕列表
export function getBarrageList(arg: {
  classtimeid: string;
  limit: string;
  page: string;
  type: string;
  order:string
}) {
  return post('/FutureV2/Barrage/lists', arg)
}
//获取自己在某个课程的权限
export function postGetCourseUserInfo(arg: {
  courseid:string
}) {
  return post('/UserApi/getUserInfoInCourse', arg)
}